import { render, staticRenderFns } from "./TextFieldMoney.vue?vue&type=template&id=2b6e927c"
import script from "./TextFieldMoney.vue?vue&type=script&lang=js"
export * from "./TextFieldMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports